import { DeliverableModel, SafeSendCustomField } from '@aiwyn/api';
import { PillColor } from '@aiwyn/shared';

export type SafeSendStatusColor = 'gray' | 'green' | 'blue' | 'orange' | 'yellow' | 'red';

const SAFESEND_STATUS_COLOR_MAP: Record<string, SafeSendStatusColor> = {
  // Gray statuses (gray-300)
  duplicate: 'gray',
  locked: 'gray',
  'mail or fax': 'gray',
  'partially signed': 'gray',
  // Green statuses (green-100)
  ready: 'green',
  'e-signed': 'green',
  'approved for delivery': 'green',
  'manually signed': 'green',
  'signed & e-signed': 'green',
  'delivered to taxcaddy': 'green',
  'alternate delivery': 'green',
  'alternate & uploaded': 'green',
  'draft approved': 'green',
  'final return copy created': 'green',
  'draft approved - ready to finalize': 'green',
  // Blue statuses (blue-200)
  processing: 'blue',
  'preparing for delivery': 'blue',
  uploaded: 'blue',
  'preparing for pdf download': 'blue',
  // Orange statuses (orange-100)
  'awaiting e-sign': 'orange',
  'awaiting upload': 'orange',
  review: 'orange',
  'to be reprocessed': 'orange',
  'awaiting draft review': 'orange',
  // Yellow statuses (yellow-100)
  'draft not approved': 'yellow',
  recalled: 'yellow',
  reprocessing: 'yellow',
  // Red statuses (red-300)
  error: 'red',
  'delivery failed': 'red',
  'non-supported': 'red',
  'taxcaddy delivery failed': 'red',
  'downloading failed': 'red',
  'signature stamping failed': 'red',
};

export function getSafeSendStatusColor(status: string): PillColor {
  const normalizedStatus = status?.toLowerCase()?.trim() || '';
  return SAFESEND_STATUS_COLOR_MAP[normalizedStatus] || 'gray';
}

export function isSafeSendDeliverable(deliverable: DeliverableModel): boolean {
  return !!deliverable?.custom_field_values?.safesend_documentId;
}

export function getSafeSendStatus(customFieldValues: SafeSendCustomField | undefined): string | undefined {
  return customFieldValues?.safesend_status;
}
